export function labelFor(v: number) {
  if (v >= 90) return 'Excellent';
  if (v >= 75) return 'Good';
  if (v >= 50) return 'Fair';
  return 'Poor';
}
